'use client';

import { useMemo } from 'react';

import { LottiePlayer } from './LottiePlayer';
import { getImageSrc } from './util/getImageSrc';

interface LottieProps {
  src: string;
  className?: string;
  loop: boolean;
  serviceName?: string;
}

/**
 * @deprecated 이 컴포넌트는 더 이상 사용되지 않습니다. 대신 LottiePlayer를 직접 사용하세요.
 *
 * @example 기존 사용법 (deprecated)
 * <Lottie src="animation.json" serviceName="care" loop={true} />
 *
 * @example 새로운 사용법 - 파일명으로 리소스센터 URL 생성
 * <LottiePlayer fileName="animation.json" serviceName="care" loop={true} />
 *
 * @example 새로운 사용법 - Full URL 직접 제공
 * <LottiePlayer src="https://example.com/animation.json" loop={true} />
 */
export function Lottie({ src, className, loop, serviceName = 'care' }: LottieProps) {
  const resource = useMemo(() => {
    return getImageSrc({ src, type: 'lottie', serviceName });
  }, [src, serviceName]);
  return <LottiePlayer src={resource} className={className || ''} loop={loop} />;
}
